(function($){

    // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');
            $('#mainMenu').fadeIn(100).animate({top: '0'});
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                  arrows: false,
                  slidesToShow: 3
                }
              }, {
                breakpoint: 900,
                settings: {
                  arrows: false,
                  slidesToShow: 3
                }
              }, {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: false,
                  slidesToShow: 1
                }
              }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


    // Initiate aos animations
	AOS.init();


    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

    $(".open").on("click", function(){
        $(".popup, .header__shopping-basket").addClass("active");
        $(".site-content").addClass("is-blurred");
        $('html, body').css({
            overflow: 'hidden',
            height: '100%'
        });
    });

    $(".close, .popup").on("click", function(){
        $(".popup, .header__shopping-basket").removeClass("active");
        $(".site-content").removeClass("is-blurred");
        $('html, body').css({
            overflow: 'auto',
            height: 'auto'
        });
    });

    $(window).on("load resize orientationchange", function() {
        $(".c-hex-clip.c-hex-border").each(function() {
            var $hexWidth = $(this).outerWidth();
            var $hexBorder = $hexWidth / 15;

            $(this).css("padding", $hexBorder+"px");
        });
    });

    $(window).on("load resize orientationchange", function() {

        var $topPad = $('.page-id-97 #siteHeader').height();
        
        $(".c-thank-you-row").css('padding-top', $topPad+'px');
        $(".c-error-row").css('padding-top', $topPad+'px');
        
    });

    $(window).on("load resize orientationchange", function() {

        var $topPad = $('#siteHeader.c-site-header-nobg').height();
        
        $(".c-thank-you-row").css('padding-top', $topPad+'px');
        $(".c-error-row").css('padding-top', $topPad+'px');
        
    });

    $(window).on("load resize orientationchange", function() {
         var $careerTopPad = $("body.single-career #siteHeader.c-site-header-nobg").height();

         $(".overlap-prevention--single").css('padding-top', $careerTopPad+'px');
    });

    $(window).on("load resize orientationchange", function() {
         var $postTopPad = $("body.single-post #siteHeader.c-site-header-nobg").height();

         $(".overlap-prevention--single").css('padding-top', $postTopPad+'px');
    });


    $(window).on("load scroll resize orientationchange", function() {
        // Hide Header on on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $("header#siteHeader").outerHeight();


        $(window).on('scroll',function (event) {
          didScroll = true;
        });

        setInterval(function () {
          if (didScroll) {
            hasScrolled();
            didScroll = false;
          }
        }, 250);

        function hasScrolled() {
          var st = $(this).scrollTop();
          navbarHeight = $("header#siteHeader").outerHeight();

          // Make sure they scroll more than delta
          if (Math.abs(lastScrollTop - st) <= delta) return;

          // If they scrolled down and are past the navbar, add class .nav-up.
          // This is necessary so you never see what is "behind" the navbar.
          if (st > lastScrollTop && st > 0) {
            // Scroll Down
            // $('header#siteHeader.nav-up').css('top', "-"+navbarHeight+"px");
            $("header#siteHeader").removeClass("nav-down").addClass("nav-up");
          } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
             // $('header#siteHeader.nav-up').css('top', 0);
              $("header#siteHeader").removeClass("nav-up").addClass("nav-down");
            }
          }

          lastScrollTop = st;
        }

        // Navbar color change
        var $nav = $("header#siteHeader");
        $nav.toggleClass("scrolled", $(this).scrollTop() > 30);
        $(window).scroll(function () {
          var $nav = $("header#siteHeader");
          $nav.toggleClass("scrolled", $(this).scrollTop() > 30);
        });
    });
    

    $(document).on("click", ".myCartclose", function(){
        $('html').css('overflow', 'auto');
        $('#myCart').css('display','none');
    });

    

})(jQuery);


( function( $, window, document, undefined ) {
	
	/**
	 * Returns a singular or plural form of a word based on value.
	 * @param value integer
	 * @param string singular The singular form of the word, e.g. star
	 * @param string plural The plural form of the word, e.g. stars
	 */
	function _n( value, singular, plural ) {
		if ( 1 == value ) {
			return singular;
		} else {
			return plural;
		}
	}

	/**
	 * Update a quantity input to a specific value.
	 * @param jQuery $input A jQuery object representing the input.
	 * @param integer value The value to update to.
	 */
	function update_input( $input, value ) {
		// Check input min/max
		var inputMin = $input.attr('min'),
				inputMax = $input.attr('max');
		if ( undefined === inputMin ) {
			inputMin = 0;
		}

		if ( undefined === inputMax ) {
			inputMax = 99999;
		}				

		if ( 
			( inputMin && value >= parseInt( inputMin ) ) && 
			( inputMax && value <= parseInt( inputMax ) ) 
		) {
			$input.val( value );
			// The gods of JavaScript have decided that I need to manually call this
			$input.trigger('change'); 
				
			// Update corresponding label
			$input.parent().siblings('.js-quantity-label').html( _n( value, $input.attr('data-singular'), $input.attr('data-plural') ) );
            $input.parent().siblings('.js-quantity-label').html( _n( value, $input.attr('data-singular'), $input.attr('data-plural') ) );
		}
	}

	/**
	 * Step a quantity input adding/removing a set value.
	 * @param jQuery $input A jQuery object representing the input.
	 * @param integer step The amount to change.
	 */
	function step_input( $input, step ) {
		var original_value = $input.val(),
				new_value = parseInt( original_value ) + parseInt( step );

		update_input( $input, new_value );
	}

	// Events
    $("body").on("click", ".js-quantity-toggle", function(e) {
		var $input = $( $(this).attr('data-target') ),
	 			step = $(this).attr('data-step');

		step_input( $input, step );

		e.preventDefault();
		return false;
	} );


   /* $('#single_add_to_cart_button').on('click', function(e){ 
        e.preventDefault();
        $thisbutton = $(this);
                    $form = $thisbutton.closest('form.cart'),
                    id = $thisbutton.val(),
                    product_qty = $form.find('input[name=quantity]').val() || 1,
                    product_id = $form.find('input[name=product_id]').val() || id,
                    variation_id = $form.find('input[name=variation_id]').val() || 0;
        var data = {
                action: 'edge_woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
            };
        $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    $('html').css('overflow', 'hidden');
                    $('#myCart').css('display','flex');
                    $('#myCart').css('justify-content','center');
                    $('#myCart').css('align-items','center');
                }, 
                success: function (response) { 
                    if (response.error & response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else { 
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                    } 
                }, 
            }); 
         }); 

         $('#multi_add_to_cart_button').on('click', function(e){ 
            e.preventDefault();
            var data = {
                action: 'edge_woocommerce_multi_ajax_add_to_cart',

            };
            $("input[name|=quantity]").each(function(){
                data[$(this).attr('data-id')] = $(this).val(); //value to update the database with
            });
            

            $.ajax({
                    type: 'post',
                    url: wc_add_to_cart_params.ajax_url,
                    data: data,
                    beforeSend: function (response) {
                       
                    },
                    complete: function (response) {
                        $('html').css('overflow', 'hidden');
                        $('#myCart').css('display','flex');
                        $('#myCart').css('justify-content','center');
                        $('#myCart').css('align-items','center');
                        $('#myCartInner').html(response.output);
                        alert("1");
                    }, 
                    success: function (response) { 
                        alert("2");
                        if (response.error & response.product_url) {
                            window.location = response.product_url;
                            return;
                        } 
                    }, 
                }); 
             });        */

          /*   $('#multi_add_to_cart_button').on('click', function(e){ 
                e.preventDefault();
                var productsData = [];          
                $("input[name|=quantity]").each(function(){
                    
                    var productId  = $(this).attr("data-id");
                    var productqty = $(this).val();
                    if(productqty > 0){
                        productsData.push({'id': productId, 'qty': productqty});
                    }
                });
                console.log(productsData); 
                multiAddToCart( productsData );
            });

            function multiAddToCart( productsData ) {
                $.ajax({
                    url: wc_add_to_cart_params.ajax_url,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        'action': 'multi_add_to_cart',
                        'items' : Object.assign({}, productsData)
                    },
                    success : function(response) {
                        $(document.body).trigger('wc_fragment_refresh'); // Refresh cart fragments
                        console.log(response);
                    },
                    error : function(error) {
                        console.log(error);
                    }
                });
            }*/


            $(document).on('click', '#multi_add_to_cart_button', function (e) {
                  e.preventDefault();
                  var nonce    = k_php_var.nonce;
                  var productsData = []; 
                  var $thisbutton = $(this);

                  $("input[name|=quantity]").each(function(){                
                      var productId  = $(this).attr("data-id");
                      var productqty = $(this).val();
                      if(productqty > 0){
                            productsData.push({'id': productId, 'qty': productqty});
                      }
                  });

                  var $thisbutton = $(this),
                  $form = $thisbutton.closest('form.cart'),
                  id = $thisbutton.val(),

                  id = productsData[0]['id'],
                  product_qty = productsData[0]['qty'] || 1,
                  product_id = productsData[0]['id'] || id
                  var data = {
                      action    : 'multi_add_to_cart',
                      nonce      : nonce,
                      product_id: product_id,
                      form_data : $(this).closest('form').serialize(),
                      'items' : Object.assign({}, productsData)
                  };
                  console.log(product_id + " - " + product_qty);
        
                  $.ajax({
                      type: 'post',
                      url: wc_add_to_cart_params.ajax_url,
                      data: data,
                      beforeSend: function (response) {
                        $thisbutton.removeClass('added').addClass('loading');
                      },
                     complete: function (response) {
                        $thisbutton.addClass('added').removeClass('loading');
                     },
                    success: function (response) {
      
                        if (response.error && response.product_url) {
                            window.location = response.product_url;
                            return;
                        } else {
                            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                        }
                      },
              
                      error: function (response) {
                        $(this).removeClass('loading');  
                        console.log("Fail");
                      }
                  });
        
                  return false;
              });
              

} )( jQuery, window, document );